function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classNames from 'classnames';
import { browserHistory } from 'react-router';
import { GiveawayGoodieSteps } from 'swag-common/interfaces';
import LoadingOverlay from 'swag-client-common/components/ui/loading-overlay';
import DemoInventoryWarningPopup from 'swag-client-common/components/popups/demo-inventory-warning-popup';
import { RemoveGoodieProductPopup } from 'swag-client-common/components/popups/remove-goodie-product-popup';
import { GiveawayUrl } from 'swag-common/utils/urls/giveaway.url';
import { ConfirmGoodieUnusedBudgetPopup } from 'swag-client-common/components/popups/confirm-goodie-unused-budget-popup';
import { isWhiteByHex } from 'swag-client-common/utils/is-white-color';
import { variables } from 'swag-client-common/styles/variables-js';
import { ImageLoading } from '../image-loading';
import { PoweredBySwagLink } from '../powered-by-swag-link';
import { GiveawayLandingBody } from '../giveaway-landing-body';
import { GiveawayLandingName } from '../giveaway-landing-name';
import { GiveawayLandingDescription } from '../giveaway-landing-description';
import { SubmitBlock } from '../../submit-block';
import GiveawayConfirmYourAddressPopup from '../../popups/giveaway-confirm-your-address-popup';
import classes from './giveaway-landing.scss';
const getColor = primaryColor => isWhiteByHex(primaryColor) ? variables.colorPrimary : primaryColor;
export class GiveawayLandingComponent extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleGoBack", () => {
      const {
        link,
        giveaway
      } = this.props;
      if (!link) {
        return;
      }
      const {
        link: route
      } = link;
      browserHistory.push(GiveawayUrl.getGiveawayUserLanding({
        link: route,
        giveawayType: giveaway === null || giveaway === void 0 ? void 0 : giveaway.giveawayType
      }));
    });
  }
  render() {
    const {
      giveaway,
      step,
      onSubmit,
      isImagesInLoading,
      disabled,
      giveawayTypeLabel,
      isLoading,
      submitButtonColor
    } = this.props;
    const isLandingPage = window.location === window.parent.location;
    if (!giveaway) {
      return null;
    }
    const {
      name,
      primaryColor,
      logo,
      description,
      budget
    } = giveaway;
    return /*#__PURE__*/React.createElement(React.Fragment, null, isLandingPage && /*#__PURE__*/React.createElement(LoadingOverlay, {
      isShown: isLoading || isImagesInLoading,
      wavedLoader: true
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        backgroundColor: primaryColor
      },
      className: classNames(classes.page, {
        [classes.loadingPage]: isImagesInLoading
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames(classes.container, {
        [classes.catalogContainer]: step === GiveawayGoodieSteps.catalog
      })
    }, /*#__PURE__*/React.createElement(ImageLoading, {
      src: logo,
      alt: "logo",
      className: classes.logo
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.divider
    }), /*#__PURE__*/React.createElement(GiveawayLandingName, {
      color: getColor(primaryColor),
      name: name
    }), /*#__PURE__*/React.createElement(GiveawayLandingDescription, {
      description: description
    }), /*#__PURE__*/React.createElement(GiveawayLandingBody, {
      step: step
    }), /*#__PURE__*/React.createElement(SubmitBlock, {
      disabled: disabled,
      onSubmit: onSubmit,
      onBack: this.handleGoBack,
      primaryColor: submitButtonColor,
      step: step,
      giveawayTypeLabel: giveawayTypeLabel,
      budget: budget
    }), /*#__PURE__*/React.createElement(PoweredBySwagLink, {
      color: getColor(primaryColor)
    }), /*#__PURE__*/React.createElement(GiveawayConfirmYourAddressPopup, {
      primaryColor: primaryColor
    }), /*#__PURE__*/React.createElement(DemoInventoryWarningPopup, null), /*#__PURE__*/React.createElement(RemoveGoodieProductPopup, null), /*#__PURE__*/React.createElement(ConfirmGoodieUnusedBudgetPopup, null))));
  }
}